import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CoffeeMaker = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M11.75 4.167c.184 0 .333.149.333.333V6a.333.333 0 1 1-.666 0V4.5c0-.184.149-.333.333-.333z" />
      <path d="M2.25 1.333A1.167 1.167 0 0 0 1.083 2.5v12.167h2.833V4.5c0-.184.149-.333.333-.333h10.167V2.5a1.167 1.167 0 0 0-1.167-1.167h-11zM.954 1.204C1.298.86 1.764.667 2.25.667h11A1.83 1.83 0 0 1 15.083 2.5v2a.333.333 0 0 1-.333.333H4.583V15a.333.333 0 0 1-.333.333H.75A.333.333 0 0 1 .417 15V2.5c0-.486.193-.953.537-1.296zM7.917 15c0-.184.149-.333.333-.333h7a.333.333 0 1 1 0 .666h-7A.333.333 0 0 1 7.917 15z" />
      <path d="M6.417 8c0-.184.149-.333.333-.333h2a.333.333 0 1 1 0 .666H7.083v1.166a.67.67 0 0 0 .667.667h.999a.333.333 0 1 1 0 .666H7.748A1.34 1.34 0 0 1 6.416 9.5V7.999z" />
      <path d="M8.417 8c0-.184.149-.333.333-.333h6c.184 0 .333.149.333.333v2.5a3.333 3.333 0 1 1-6.666 0V8zm.666.333V10.5a2.668 2.668 0 0 0 5.334 0V8.333H9.084z" />
    </svg>
  );
};

CoffeeMaker.category = 'product-category';

CoffeeMaker.displayName = 'CoffeeMaker';
